<template>
  <mdb-container v-if="folder">
    <banner :group="currentGroup"/>
    <mdb-row>
      <mdb-col class="text-left" md="12">
        <mdb-card class="text-left">
          <mdb-card-header>
            {{ folder.name }}
          </mdb-card-header>
          <mdb-card-body>
            <mdb-list-group>
              <mdb-list-group-item v-bind:key="file.id"
                                   v-for="file in folder.files">

                <a href="" @click.prevent="download(file)">{{file.name}}</a>

              </mdb-list-group-item>
            </mdb-list-group>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardText,
  mdbCardTitle,
  mdbContainer,
  mdbListGroup,
  mdbListGroupItem
} from 'mdbvue';
import Banner from "./Banner"
import download from "js-file-download";

export default {
  name: 'folder-page',
  components: {
    Banner,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbListGroup,
    mdbListGroupItem
  },
  computed: {
    currentGroup() {
      return this.$store.state.currentGroup
    },
    settings() {
      return this.$store.state.settings
    },
  },
  data() {
    return {
      folder: null
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)
    let url = "/groupFile/folder/" + this.$route.params.folderId
    api.get(url).then(
      (details) => {
        this.folder = details.data
        document.title = this.folder.name
        if (!this.currentGroup || this.currentGroup.id != this.folder.groupId) api.groupBasics(this.folder.groupId, "public")
      },
      (error) => {
        this.$notify.error({message: error.response.data})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    download(file) {
      this.$store.dispatch("setExecuting", true)
      api.getBlob("/groupFile/download/" + file.id + "/?accessCode=" + file.accessCode, {}).then(
        (res) => {
          let filename = "download.file"
          let cd = res.headers["content-disposition"]
          if (cd) {
            let parts = cd.split('"')
            if (parts.length >0) filename = parts[1]
          }
          download(res.data, filename)
        },
        (error) => {
          if (error.response.status == 403) this.$notify.error({message: "You don't have access to that file.", timeOut: 4000})
          else this.$notify.error({message: "Could not retrieve file - " + error.response.status, timeOut: 4000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }

}
</script>

